import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { formatDate } from '@frontend/date';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import {
  Button,
  ModalControlTriggerProps,
  SearchField,
  TableInstance,
  Text,
  useDebouncedValue,
  useDidUpdate,
  useFormField,
} from '@frontend/design-system';
import { CollectionFilterButton } from './collection-filter-button';

type TableTopToolbarProps = {
  syncDate?: string;
  tableInstance: TableInstance<GetPatientsBalanceResponse_PatientBalance>;
  triggerProps: ModalControlTriggerProps;
};
export const TableTopToolbar = ({ tableInstance, syncDate, triggerProps }: TableTopToolbarProps) => {
  const globalSearch = useFormField({ type: 'text' }, []);
  const debouncedValue = useDebouncedValue(globalSearch.value, 300);

  useDidUpdate(() => {
    tableInstance.setGlobalFilter(debouncedValue);
  }, [debouncedValue]);

  return (
    <div css={{ display: 'flex', alignItems: 'center', flex: 1 }}>
      <div css={{ flex: 1 }}>
        {!!tableInstance.selectedFlatRows.length && (
          <Button variant='tertiary' size='large' {...triggerProps}>
            {`Create (${tableInstance.selectedFlatRows.length}) Requests`}
          </Button>
        )}
      </div>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          justifyContent: 'flex-end',
          gap: theme.spacing(2),
        }}
      >
        <div>{syncDate && <LastSynced date={syncDate} />}</div>
        <SearchField
          placeholder={'Search'}
          name='Global Table Search'
          data-trackingid={'tableTrackingIds.globalSearch'}
          css={{
            width: 250,
          }}
          {...globalSearch}
        />
        <CollectionFilterButton
          handleFilter={({ key, val }: { key: string; val: string }) => {
            tableInstance.columns.forEach((column) => {
              if (column.id === key) {
                console.log('key', { key, val });
                column.setFilter(val);
              }
            });
          }}
          selectedFilters={tableInstance.state.filters}
        />
      </div>
    </div>
  );
};

const LastSynced = ({ date }: { date: string }) => {
  const { t } = useTranslation('payments');
  return (
    <Text size='small' color='subdued'>
      <i>
        {t('Last Synced ')} {formatDate(date, 'MMMM D, YYYY h:mm a')}
      </i>
    </Text>
  );
};
